// Mirrors service_request.quote_version: v1 = legacy invoice_content, v2 = quote tables.
export enum QuoteVersion {
  v1 = 1,
  v2 = 2,
}

// Interpolation params an invoice translation can need but which CANNOT be
// derived from the catalog product — they are per-line business data, so admin
// has to type them when building a quote by hand. Everything else is resolved
// from the product by INTERPOLATION_PROP_RESOLVERS.
//
// To add one: add a member here, then add the matching input to the quote
// dialog. `requiredManualInterpolationProps` will start reporting it for any
// translation that references it, so nothing else needs to change.
export enum ManualInterpolationProp {
  trademarkNumber = 'trademarkNumber',
}
